<template>
  <div
    class="navbar no-select"
    :key="this.$route.fullPath"
    :class="{ 'navbar--transparent': useTransparentNavbar, navBarFix: scrolled }"
  >
    <nav class="navbar__nav" role="navigation" aria-label="main navigation">
      <div class="navbar__left">
        <router-link class="navbar__brand" :to="{ name: isLoggedIn ? 'companies' : 'login' }">
          <component
            :is="useTransparentNavbar && !scrolled ? 'logo-light-svg' : 'logo-svg'"
            class="navbar__brand-logo"
          />
        </router-link>
        <span class="navbar_title is-hidden-mobile" v-if="title">{{ title }}</span>
      </div>

      <div id="navbar-main" class="navbar_menu" v-if="isLoggedIn" :class="{'is-active': isOpen}">
        <div class="navbar-start">
          <router-link
            v-for="nav in loggedInNav"
            :key="nav.name"
            :to="nav.path"
            @click.native="closeSidebar()"
            :class="{'active': isActive(nav.path)}"
            class="navbar-item"
          >
            {{nav.name}}
          </router-link>
        </div>
      </div>

      <div class="navbar__right-menu" v-if="!isLoggedIn && isShowLogin">
        <router-link
          :to="{ name: 'login' }"
          class="navbar__button"
          :class="{ 'navbar__button--white': useTransparentNavbar }"
          >Log in</router-link
        >
      </div>

      <div class="navbar__right-menu" v-if="isLoggedIn">
        <router-link
          v-if="profile"
          :to="{ name: 'profile' }"
          class="navbar__item is-hidden-mobile"
          :class="{ 'navbar__button--white': useTransparentNavbar }"
          >{{ profile.first_name }} {{ profile.last_name }}</router-link
        >
        <a
          type="button"
          @click="route()"
          class="navbar__icon"
          :class="{ 'navbar__icon--open': isOpen, 'navbar__icon--close': !isOpen }"
        >
          <transition name="fade" mode="out-in">
            <settings-icon :key="'settings-icon'" />
            <!-- <close-icon :key="'close-icon'" v-else /> -->
          </transition>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import LogoLightSvg from '../../assets/img/img_logo_light.svg';
  // import LogoSvg from '../../assets/img/img_logo.svg';
  import LogoSvg from '@/assets/img/wowzi_logo.svg';
  import SettingsIcon from '../../assets/img/icons/settings.svg';
  import CloseIcon from '../../assets/img/icons/close.svg';

  export default {
    name: 'Navbar',
    props: {
      title: String,
    },
    components: {
      LogoSvg,
      LogoLightSvg,

      SettingsIcon,
      CloseIcon,
    },
    created() {
      if (
        window.location.href.indexOf('auth/login') > -1
        || window.location.href.indexOf('auth/signup') > -1
        || window.location.href.indexOf('facebook') > -1
        || window.location.href.indexOf('instagram') > -1
        || window.location.href.indexOf('twitter') > -1
      ) {
        this.isShowLogin = false;
      }
      this.$on('updateTitle', (data) => {
        this.tile = data.value;
      });
    },
    data() {
      return {
        isOpen: false,
        path: '',
        scrolled: false,
        isShowLogin: true,
        screen: window.innerWidth,
        loggedInNav: [
          {
            name: 'Dashboard',
            path: '/companies',
          },
        ],
      };
    },

    beforeMount() {
      this.scrolled = false;
      window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    computed: {
      ...mapState('Auth', ['isLoggedIn', 'profile']),
      showLoginButton() {
        if (this.isLoggedIn) return false;
        return ['auth', 'thank-you'].includes(this.$route.name);
      },
      showLogoutButton() {
        return this.isLoggedIn;
      },
      useTransparentNavbar() {
        return ['auth'].includes(this.$route.name);
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler(to) {
          this.path = to.path;
        },
      },
    },
    methods: {
      isActive(path) {
        return this.path === path ? 'active' : '';
      },
      closeSidebar() {
        this.isOpen = false;
      },
      handleScroll() {
        this.scrolled = window.scrollY > 20;
      },
      route() {
        if (this.$route.path !== '/profile/') this.$router.push({ name: 'profile-details' });
        else window.location.reload();
      },
    },
  };
</script>

<style lang="scss">
@import "../../../node_modules/bulma/sass/utilities/mixins";
@import "../../assets/styles/variables";

.navbar {
  min-height: 0;
  height: 80px;
  width: 100vw;
  background-color: $background-4;
  box-sizing: border-box;
  position: fixed;
  // position: absolute;
  top: 0;

  &.navbar--transparent {
    background-color: transparent;
  }

  @include mobile {
    min-height: 48px;
    height: 48px;
  }

  .navbar__nav {
    height: 100%;
    width: 1240px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    gap: 12px;
    padding: 0;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 1440px) {
      padding: 0 100px;
      width: 100%;
    }
    @media (max-width: 996px) {
      padding: 0 16px;
    }
    @include mobile {
      padding: 0;
    }
  }

  .navbar__brand {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;

    @include mobile {
      height: 48px;
    }

    .navbar__brand-logo {
      width: 64px;
      height: 64px;
      margin: 0;

      @include mobile {
        // height: 40px;
        // width: 40px;
        margin: 4px 12px;
        transform: scale(.65);
      }
      @media(max-width: 575px) {
        margin: 4px 4px;
      }
    }
  }

  .navbar__left {
    display: flex;
  }
  .navbar_title {
    font-family: Open Sans, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    margin: auto 32px;

    display: flex;
    align-items: center;
    align-self: flex-start;
    position: relative;
    color: $secondary-main;
  }

  .navbar__center-menu {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;

    .navbar__item {
      font-size: 24px;
      line-height: 28px;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      color: $secondary-main;
    }

    .navbar__button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      font-size: 16px;
      line-height: 16px;
      border-radius: 24px;
      background-color: $secondary-main;
      color: $white;
      margin-left: 24px;
      transition: all 0.2s ease-in-out;

      &:not(:hover) {
        @include shadow-1;
      }
    }
  }

  .navbar_menu {
    display: flex;
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 0;
    .navbar-item,
    .navbar-item a {
      font-weight: bold;
      display: flex;
      align-items: center;
      position: relative;
      text-align: center;
      color: $text-light;
    }
  }

  .navbar__right-menu {
    display: flex;
    position: relative;
    align-items: center;
    float: right;

    .navbar__item {
      color: $primary-main;
    }

    .navbar__icon {
      display: block;
      width: 24px;
      height: 24px;
      font-size: 24px;
      line-height: 24px;
      margin-left: 20px;
      position: relative;

      @include mobile {
        margin: 0 16px;
      }

      &.navbar__icon--open {
        fill: $gradient-4;
      }

      &.navbar__icon--close {
        fill: $gradient-1;
      }
    }

    .navbar__button {
      width: 120px;
      height: 40px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      text-transform: uppercase;
      font-size: 14px;
      line-height: 20px;
      background-color: $secondary-main;
      color: $white;

      @include mobile {
        border-radius: 0;
        height: 100%;
        width: auto;
        padding: 0 16px;
        background-color: transparent;
        color: $secondary-main;
      }

      &.navbar__button--white {
        background-color: $white;
        color: $secondary-main;

        @include mobile {
          background-color: transparent;
          color: $background-4;
        }
      }
    }
  }
}
.navBarFix {
  background-color: $white !important;
  -webkit-box-shadow: 0 2px 4px 3px $default-nav-shadow;
  box-shadow: 0 3px 8px 10px $default-nav-shadow;
}
</style>
